import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {ManualLayout} from '@/components/manual/manual-layout'
import {useManualSeo} from '@/components/manual/use-manual-seo'
import {Reveal} from '@/components/reveal'
import {MANUAL_GRUPOS} from '@/manual'

export function ManualIndexPage() {
  const {t} = useTranslation()
  useManualSeo(t('manual.title'), t('manual.metaDescription'))

  let sectionCounter = 0

  return (
    <ManualLayout>
      <div className="space-y-16">
        <div className="max-w-2xl">
          <p className="font-mono text-[11px] font-semibold tracking-[0.14em] text-primary uppercase">
            {t('manual.eyebrow')}
          </p>
          <h1 className="mt-2 font-heading text-3xl tracking-tight text-foreground sm:text-4xl">{t('manual.title')}</h1>
          <p className="mt-3 text-sm text-muted-foreground sm:text-base">{t('manual.intro')}</p>
        </div>

        {MANUAL_GRUPOS.map((grupo, gi) => (
          <section key={grupo.id} className="space-y-5">
            <div className="border-b border-border pb-3">
              <div className="flex items-baseline gap-3">
                <span className="font-mono text-sm font-semibold text-primary">{String(gi + 1).padStart(2, '0')}</span>
                <h2 className="font-heading text-lg text-foreground">{grupo.titulo}</h2>
              </div>
              {grupo.descripcion && (
                <p className="mt-1 max-w-2xl pl-7 text-sm text-muted-foreground">{grupo.descripcion}</p>
              )}
            </div>
            <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
              {grupo.secciones.map((seccion) => {
                sectionCounter += 1
                return (
                  <Reveal key={seccion.id} delayMs={(sectionCounter % 6) * 40}>
                    <Link
                      to={`/manual/${seccion.id}`}
                      data-testid={`manual-card-${seccion.id}`}
                      className="surface surface-raised flex h-full flex-col gap-2 rounded-xl p-5 outline-none focus-visible:ring-2 focus-visible:ring-ring/50">
                      <span className="font-mono text-xs font-semibold text-muted-foreground">
                        {String(sectionCounter).padStart(2, '0')}
                      </span>
                      <h3 className="font-heading text-base text-foreground">{seccion.titulo}</h3>
                      <p className="line-clamp-3 text-sm text-muted-foreground">{seccion.resumen}</p>
                    </Link>
                  </Reveal>
                )
              })}
            </div>
          </section>
        ))}
      </div>
    </ManualLayout>
  )
}
